import { Component } from 'react';


interface IProps {

}

interface IState {
    str:string;
}

export class AnnouncementsController extends Component<IProps, IState> {

    
     
    state: IState = {
        str:""
       
    };
    search = async (e:any) => {
        this.setState({ str: e })
    };
    
    
}
export default AnnouncementsController;